import { render, staticRenderFns } from "./FormValidation.vue?vue&type=template&id=f59b7320&"
import script from "./FormValidation.vue?vue&type=script&setup=true&lang=js&"
export * from "./FormValidation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports